<template>
  <div id="evaluate-result">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper" id="evaluate-result-wrapper" :class="{'binScroll':!isVip}">
      <!--      <div class="section section1">-->
      <!--        <div class="title">评测结果</div>-->
      <!--      </div>-->
      <div class="section section2">
        <div class="title">企业安全风险评测结果</div>
        <div class="subtitle">-- 评测得分依据您企业评测内容综合分析判定 --</div>
        <div class="circle-box">
          <div class="tip">安全评测</div>
          <div class="value">{{riskData.newUserResult.total_score}}<span>分</span></div>
        </div>
        <div class="rank-box" :class="{'markBlur':!isVip}">
          <div class="left">
            <img src="../assets/icon_eva_rank.jpg">
            <span class="tip">企业排名:&nbsp;</span><span class="value">{{riskData.newUserResult.risk_user_rank}}</span>&nbsp;&nbsp;<span class="rank" @click="goToRank">提升排名></span>
          </div>
          <div class="right">
            <div class="top"><span class="tip">同行业平均分：</span><span class="value">{{riskData.newUserResult.industry_avg_score}}分</span>&nbsp;<span class="line">/</span>&nbsp;<img src="../assets/icon_eva_rank.jpg">&nbsp;<span class="rank">{{riskData.newUserResult.industry_rank}}</span></div>
            <div class="bottom"><span class="tip">同区域平均分：</span><span class="value">{{riskData.newUserResult.region_avg_score}}分</span>&nbsp;<span class="line">/</span>&nbsp;<img src="../assets/icon_eva_rank.jpg">&nbsp;<span class="rank">{{riskData.newUserResult.region_rank}}</span></div>
          </div>
        </div>
      </div>
      <div class="section section3" :class="{'markBlur':!isVip}" v-if="!riskData.newUserResult.isZan">
        <div class="header">
          <div class="line"></div>
          <span class="title"><span>/</span>&nbsp;&nbsp;导致企业风险发生的概率&nbsp;&nbsp;<span>/</span></span>
        </div>
        <div class="rate-chart-box" id="rate-chart-box">
          <i-circle class="rate-circle" style="position: relative;width: 100px;height:100px;" v-for="(value,index) in riskData.resultRateList" :key="index" :percent="value.risk_rate" stroke-color="#c41335"></i-circle>
        </div>
        <div class="rate-chart-value">
          <div class="rate-value" v-for="(value,index) in riskData.resultRateList" :key="index">
            <span class="rate">{{value.risk_rate}}%</span>
            <span class="title">{{value.category_name}}</span>
          </div>
        </div>
      </div>
      <div class="section section3 section33" v-if="riskData.newUserResult.isZan">
        <img src="../assets/icon-eva-zan.png">
        <div>目前您的企业安全防范措施<span style="font-style: italic">非常不错</span>，请再接再厉！</div>
      </div>
      <div class="section section4" :class="{'markBlur':!isVip}" v-if="riskData.newUserResult.isSS">
        <div class="header">
          <div class="line"></div>
          <span class="title"><span>/</span>&nbsp;&nbsp;设施不完善<span style="color: #c41335;">导致风险</span>&nbsp;&nbsp;<span>/</span></span>
        </div>
        <div class="content">
          <swiper class="swiperRate" :options="swiperOptionRate" ref="swiperRate">
            <swiper-slide v-for="(value,index) in riskData.deviecList" :key="index">
              <div class="chart">
                <div style="z-index: 2;" :id="forId(index)"></div>
              </div>
            </swiper-slide>
          </swiper>
          <div v-if="riskData.deviecList.length>1" class="swiper-pagination" slot="pagination"></div>
        </div>
      </div>
      <div class="section section5" :class="{'markBlur':!isVip}">
        <div class="header">
          <div class="line"></div>
          <span class="title"><span>/</span>&nbsp;&nbsp;企业实际情况综合分析报告&nbsp;&nbsp;<span>/</span></span>
        </div>
        <div class="tip-box" :hidden="riskData.newUserResult.total_score>=100&&riskData.newUserResult.isSS<=0">
          <img src="../assets/icon-warn.jpg">
          <div class="tip">本单位未按照《消防法》相关规定落实消防安全工作，请立即整改，如后续抽查不合格，将面临停业整改，并可处最高三十万元罚款。</div>
        </div>
        <div class="content">
          <div class="header">
            <div class="tip">根据国家法律法规及相关规范标准，参考国家消防规范
              <br/><a @click="ruleClick(0)">《中华人民共和国消防法》</a>、
              <br/><a @click="ruleClick(1)">《自动喷水灭火系统设计规范》GB 50084-2017</a>、
              <br/><a @click="ruleClick(2)">《建筑灭火器配置设计规范》GB 50140-2005</a>、
              <br/><a @click="ruleClick(3)">《火灾探测器（烟感温感）设置与安装规范》<br/></a>
            </div>
          </div>
          <div class="center">
            <div class="item-box item-box1">
              <div class="title" v-if="riskData.newUserResult.isSS">消防设施：</div>
              <div class="value" v-for="(value,index) in riskData.siteDeviecList" :key="index">
                <span class="index1" v-show="value.show">{{index + 1 + '.'}}</span>
                <span class="title1" v-show="value.show">{{value.name}}：</span>
                <div class="value2" v-for="(value2,index2) in value.siteUserDeviceList" :key="index2">
                  <span class="title2" v-show="value2.show"><a :href="value2.content">{{value2.device_name}}</a><span>：应至少再增加</span>{{value2.norm_number - value2.real_number}}<span>个</span></span>
                </div>
                <div class="tip-title" v-show="value.ageContentList.length>0">维护保养：</div>
                <div v-for="(item,i) in value.ageContentList" style="margin-top: 10px;">
                  {{i+1}}.<span class="tip-value" v-html="item"></span>
                </div>
                <div class="tip2-title" v-show="value.subList.length>1&&value.showsub">{{value.name + '内所有场地应配置的设施设备'}}</div>
                <div :id="'tipShowText'+index" class="tip3-btn" v-show="value.subList.length>1&&value.showsub" @click="showClick(value,index)">【点击展开】</div>
                <div class="item-box2" v-show="value.isSel&&value.subList.length>1" v-for="(value2,index2) in value.subList" :key="'info'+index2">
                  <div class="title2" v-show="value2.show">{{value2.name}}：</div>
                  <div class="value2" v-show="value2.show" v-for="(value3,index3) in value2.siteUserDeviceList" :key="'info'+index3">
                    <span class="title3" v-show="value3.show"><a :href="value3.content">{{value3.device_name}}</a><span>：应至少再增加</span>{{value3.norm_number - value3.real_number}}<span>个</span></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-box" v-for="(value,index) in riskData.repairList" :key="index">
              <div class="title">{{value.group_name + '：'}}</div>
              <div class="value"  v-for="(item,index1) in value.list" :key="index1">
                <span class="index1">{{index1 + 1 + '.'}}</span>
                <span class="tipvalue1" v-html="item"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-box" :hidden="riskData.newUserResult.total_score>=100&&riskData.newUserResult.isSS<=0">
          <img src="../assets/icon-warn.jpg">
          <div class="tip">请根据以上整改项目进行操作，如后续抽查不合格，将面临停业整改，并可处最高三十万元罚款。</div>
        </div>
      </div>
    </div>

    <div class="mark-view" v-show="!isVip">
      <div class="content">依据&nbsp;<span>大数据精准</span>&nbsp;分析，<br/><span>360°提升</span>&nbsp;企业抗风险能力</div>
      <div class="lookBtn" @click="lookResultClick">获取报告</div>
    </div>
    <bottomButton v-show="isVip&&riskData.newUserResult.isSS" :title='bottomTitle' :state="1" @click="bottomClick"></bottomButton>
    <bottomButton2 v-show="isVip&&riskData.newUserResult.isSS" title1='导出报告' :title2='bottomTitle' :state="1" @click="bottomClick2"></bottomButton2>
    <bottomButton v-show="isVip&&!riskData.newUserResult.isSS" title='导出报告' :state="1" @click="bottomClick3"></bottomButton>
    <!--  支付弹窗  -->
    <payView type="3" :show="payViewVisible" @payValue="payValue"></payView>
    <AlertView :show="showAlert" title="" :subTitle="alerViewTitle" cancelTitle="取消" :sureTitle="alertSureTitle" @alertViewClick="alertViewClick" ></AlertView>
    <previewImage :show="photoUrl.length > 0" :imgUrl="photoUrl" @previewClick="previewClick"></previewImage>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import bottomButton2 from '../components/bottom-button2'
import { Toast, Indicator } from 'mint-ui'
import payView from '../components/pay'
import AlertView from '../components/alert-view'
import previewImage from '../components/preview-image'
import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      inject: ['reload'], // 界面刷新
      payViewVisible: false,
      isVip: 0, // 是否 是支付过的用户
      rulesPDF: [
        'http://cdn.zxzx119.com/44565756745456546.pdf',
        'http://cdn.zxzx119.com/15645324534656545.pdf',
        'http://cdn.zxzx119.com/234546754643.pdf',
        'http://cdn.zxzx119.com/334654756875.pdf'
      ],
      riskData: {
        'newUserResult': {},
        'siteDeviecList': [],
        'deviecList': []
      },
      showAlert: false,
      alerViewTitle: '',
      alertSureTitle: '',
      bottomTitle: '一键解决',
      onceOrder: 0, // 再来一单
      orderListData: [], // 未支付订单
      photoUrl: '', // 结果页 截图
      swiperOptionRate: {
        loop: false,
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'rate-bullet',
          bulletActiveClass: 'rate-bullet-active'
        }
      }
    }
  },
  methods: {
    binScroll: function () {
      var mo = function (e) {
        // e.preventDefault()
      }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false) // 禁止页面滑动
    },
    startScroll: function () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = '' // 出现滚动条
      document.removeEventListener('touchmove', mo, false)
    },
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
      // this.$router.replace('home')
    },
    forId: function (index) { // 获取验证码
      return 'rate2Chart' + (index + 1)
    },
    goToRank: function () {
      this.$router.push({path: 'safe-manager'})
    },
    alertViewClick: function (index) {
      this.showAlert = false
      if (index === 1) {
        window.location.href = this.pcOrderList
      }
    },
    getBlob: function (canvas) { // 获取blob对象
      var data = canvas.toDataURL('image/jpeg', 1)
      data = data.split(',')[1]
      data = window.atob(data)
      var ia = new Uint8Array(data.length)
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i)
      }
      return new Blob([ia], {
        type: 'image/jpeg'
      })
    },
    previewClick: function () { // 关闭图片预览
      this.startScroll()
      this.photoUrl = ''
    },
    bottomClick3: function () {
      this.bottomClick2(0)
    },
    svgToCanvas: function (targetElem) {
      this.binScroll()
      // 动画
      Indicator.open({
        spinnerType: 'fading-circle'
      })

      if (targetElem.length > 0) {
        var nodesToRecover = []
        var nodesToRemove = []
        let svgElem = targetElem
        let svg1 = svgElem[0]
        let svg2 = svgElem[1]
        let svg3 = svgElem[2]

        console.log(svgElem.length)
        for (let i = 0; i < 3; i++) {
          // var node = svgElem[i]
          var node = ''
          if (i === 0) {
            node = svg1
          }
          if (i === 1) {
            node = svg2
          }
          if (i === 2) {
            node = svg3
          }
          var parentNode = node.parentNode
          var svg = parentNode.innerHTML

          var canvas = document.createElement('canvas')

          this.canvg(canvas, svg)
          canvas.style.marginLeft = '-50px'
          canvas.style.top = 0
          canvas.style.width = '200%'
          canvas.style.height = '100%'

          nodesToRecover.push({
            parent: parentNode,
            child: node
          })
          parentNode.removeChild(node)

          nodesToRemove.push({
            parent: parentNode,
            child: canvas
          })
          parentNode.appendChild(canvas)
        }
      }
      let _this = this
      var canvas2 = document.createElement('canvas')
      let _canvas = document.getElementById('evaluate-result-wrapper')
      var w = parseInt(window.getComputedStyle(_canvas).width)
      var h = parseInt(window.getComputedStyle(_canvas).height)
      // console.log('width=========' + w)
      // console.log('height=========' + h)
      // 将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
      canvas2.width = w * 1
      canvas2.height = h * 1
      canvas2.style.width = w + 'px'
      canvas2.style.height = h + 'px'
      // 可以按照自己的需求，对context的参数修改,translate指的是偏移量
      var context = canvas2.getContext('2d')
      context.scale(1, 1)
      var offsetY = window.pageYOffset + 55
      if (this.utils.isIphone()) {
        offsetY = 55
      }
      var time = 5000
      if (this.utils.myBrowser() === 'UC') {
        time = 20000
      }
      setTimeout(function () {
        _this.html2canvas(_canvas, {
          // canvas: canvas2,
          // flashcanvas: "../external/flashcanvas.min.js",
          // logging: true,
          profile: true,
          useCORS: true,
          allowTaint: true,
          x: 0,
          y: offsetY
        }).then(function (canvas) {
          _this.photoUrl = canvas.toDataURL()

          // 关闭动画
          Indicator.close()
        })
      }, time)

      // 统计
      this.utils.listenEvent(16, '', window.location.href, '')
    },
    bottomClick2: function (index) {
      if (index === 0) { // 导出报告
        let svgElem = document.getElementsByTagName('svg')
        this.svgToCanvas(svgElem)
      }
      if (index === 1) { // 一键解决
        this.bottomClick()
      }
    },
    bottomClick: function () {
      // Toast('请登录网页端操作企业风险“一键解决”')
      var _this = this
      console.log(this.orderListData)
      if (this.orderListData.length > 0) { // 未支付订单
        this.showAlert = true
        this.alerViewTitle = '您有' + this.orderListData.length + '个整改的消防设施订单未付款'
        this.alertSureTitle = '前往整改'
      } else { // 无未支付订单
        var devList = []
        if (this.onceOrder === 1) { // 再来一单
          //      	for (let i = 0; i < this.riskData.siteDeviceGoodsList.length; i++) {
          //          let item = this.riskData.siteDeviceGoodsList[i]
          //          let number = item.req_number - item.commit_number // Math.abs(item.commit_number % item.req_number)
          //          // if (number > 0 || item.commit_number === 0) {
          //          if (number > 0) {
          //            item.tails.number = number // item.req_number - number
          //            item.tails.riskeval_result_id = item.result_id
          //            devList.push(item.tails)
          //          }
          //        }

          var listObj = {}
          for (let i = 0; i < this.riskData.deviecList.length; i++) {
            //          for (let j = 0; j < this.riskData.deviecList[i].list.length; j++) {
            //            let item = this.riskData.deviecList[i].list[j]
            for (let j = 0; j < this.riskData.deviecList[i].siteUserDeviceList.length; j++) {
              let item = this.riskData.deviecList[i].siteUserDeviceList[j]

              console.log(i + '------' + j + '---------' + item.tails.goods_id)
              let number = item.norm_number - item.real_number
              if (number > 0) {
                if (listObj.hasOwnProperty(item.tails.goods_id)) {
                  console.log('000===============' + item.tails.supplier_id)
                  // listObj[item.supplier_id] = item.tails
                  listObj[item.tails.goods_id].number += number
                } else {
                  let obj = {}
                  console.log('1111===============' + item.tails.goods_id)
                  item.tails.number = number
                  item.tails.riskeval_result_id = item.result_id
                  obj = item.tails
                  listObj[item.tails.goods_id] = obj // item.tails
                }
              }
            }
          }
          for (let key in listObj) {
            devList.push(listObj[key])
          }
        } else { // >0 第一次购买 <0 再来一单后
          console.log('再来一单后 =========================')
          for (let i = 0; i < this.riskData.siteDeviceGoodsList.length; i++) {
            console.log('-----------' + i)
            let item = this.riskData.siteDeviceGoodsList[i]
            let number = item.req_number - item.commit_number // Math.abs(item.commit_number % item.req_number)
            // if (number > 0 || item.commit_number === 0) {
            if (number > 0) {
              item.tails.number = number // item.req_number - number
              item.tails.riskeval_result_id = item.result_id
              devList.push(item.tails)
            }
          }
        }
        console.log('参数=============----------')
        console.log(devList)
        if (devList.length > 0) { // 还需要 购买的商品
          let resultId = this.$route.query.resultId
          localStorage.setItem('resultId', resultId)
          localStorage.setItem('onceOrder', this.onceOrder)
          this.utils.POSTQS(this.companyUrl + '/shoppingCart/matchingGoods', false, devList, function (response) {
            localStorage.removeItem('shop')
            localStorage.setItem('shop', JSON.stringify(response.data))
            _this.$router.push({ path: 'purchasing' })
          })
        }
      }
      let resultId = this.$route.query.resultId
      // 统计
      this.utils.listenEvent(17, resultId, window.location.href, '')
    },
    lookResultClick: function () { // 查看 报告 支付
      this.payViewVisible = true
    },
    ruleClick: function (index) {
      window.location.href = this.rulesPDF[index]
    },
    showClick: function (value, index) {
      if (value.isSel === 1) {
        document.getElementById('tipShowText' + index).innerText = '【点击展开】'
        value.isSel = 0
      } else {
        document.getElementById('tipShowText' + index).innerText = '【点击收起】'
        value.isSel = 1
      }
    },
    payValue: function (state) {
      console.log('============支付回调')
      this.payViewVisible = false
      if (state === 1) { // 支付成功
        this.reload()
      }
    },
    initECharts: function () {
      // 基于准备好的dom，初始化echarts实例
      for (let i = 0; i < this.riskData.deviecList.length; i++) {
        let item = this.riskData.deviecList[i]
        var itemList = []
        var normalList = []
        var realList = []
        for (let j = 0; j < item.siteUserDeviceList.length; j++) {
          let obj = item.siteUserDeviceList[j]
          normalList.push(obj.norm_number)
          realList.push(obj.real_number)
          itemList.push(obj.device_name)
        }
        var rate2Chart = this.echarts.init(document.getElementById('rate2Chart' + (i + 1)))
        // 指定图表的配置项和数据
        var option = {
          color: ['#c41335', '#003366'],
          title: {
            text: item.name,
            x: 'center',
            textStyle: {
              color: '#000000',
              fontWeight: 'bold',
              fontSize: 15,
              textAlign: 'center'
            }
          },
          tooltip: {},
          grid: {
            left: '0%',
            right: '0%',
            width: '100%',
            top: 85,
            bottom: 35,
            containLabel: true
          },
          legend: {
            orient: 'vertical',
            left: 4,
            top: 30,
            itemGap: 8,
            itemWidth: 11,
            itemHeight: 11,
            data: ['按照国家应安装个数', '实际安装个数']
          },
          xAxis: {
            type: 'category',
            data: itemList.map(function (str) {
              var value = str
              if (str.length > 3) {
                value = value.slice(0, 3) + '\n' + value.slice(3)
              }
              return value
            }),
            axisLabel: {
              interval: 0
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '按照国家应安装个数',
              type: 'bar',
              barWidth: 20,
              data: normalList,
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  color: '#808080'
                }
              }
            },
            {
              name: '实际安装个数',
              type: 'bar',
              barWidth: 20,
              data: realList,
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  color: '#808080'
                }
              }
            }
          ]
        }
        // 使用刚指定的配置项和数据显示图表。
        rate2Chart.setOption(option)
      }
    },
    loadData: function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0

      var _this = this
      let resultId = this.$route.query.resultId
      //    this.utils.GET(this.accountUrl + '/riskeval/getResultById?resultId=' + resultId, function (response) {
      this.utils.GET(this.accountUrl + '/riskevalNew/getResultById?resultId=' + resultId, function (response) {
        // 数据处理
        let data = response.data

        if (parseInt(response.code) === 50004) { // 需先付款才能查看结果
          console.log('评测结果--------------------0')
          _this.isVip = 0
          data.siteDeviecList = []
          _this.riskData = data
          _this.payViewVisible = true
        } else {
          if (response.message === '未登录') {
            Toast('您还未登录，请登录后查看！')
            _this.$router.push({path: 'home'})
            return
          }
          console.log('评测结果--------------------1')
          _this.isVip = 1
          for (let i = 0; i < data.repairList.length; i++) {
            let item = data.repairList[i]
            let list = item.repair_content.split('zxzx2019')
            item.list = list
          }
          let isZan = 1
          for (let i = 0; i < data.resultRateList.length; i++) {
            let item = data.resultRateList[i]
            if (item.category_true_score < item.category_total_score) {
              isZan = 0
            }
          }
          // 是否 赞
          data.newUserResult.isZan = isZan
          // 是否有 设备
          // var isSS = 0
          // 反馈结果 处理
          for (let i = 0; i < data.siteDeviecList.length; i++) {
            let item = data.siteDeviecList[i]
            item.show = 0
            // 初始化未 展开数据
            item.isSel = 0
            // 无三级产所
            if (item.subList === undefined) {
              item.subList = []
            }
            // 无维修保养
            if (_this.utils.isNull(item.ageContent)) {
              item.ageContent = ''
            }
            // 消防设施
            // 二级 分类
            for (let j = 0; j < item.siteUserDeviceList.length; j++) {
              let item2 = item.siteUserDeviceList[j]
              item2.show = 0
              if (item2.norm_number > item2.real_number) {
                item.show = 1
                item2.show = 1
              }
            }
            // 三级分类
            if (item.subList.length > 0) {
              var shownum = 0
              for (let j = 0; j < item.subList.length; j++) {
                let item2 = item.subList[j]
                item2.show = 0
                for (let m = 0; m < item2.siteUserDeviceList.length; m++) {
                  let item3 = item2.siteUserDeviceList[m]
                  item3.show = 0
                  if (item3.norm_number > item3.real_number) {
                    item.show = 1
                    item2.show = 1
                    item3.show = 1
                  }
                }
                if (item2.show === 1) {
                  shownum += 1
                }
              }
            }
            // if (item.show === 1) {
            //   isSS = 1
            // }
            if (item.ageContent.length > 0) { // 有保养信息
              item.show = 1
            }
            item.showsub = 0
            if (shownum > 1) {
              item.showsub = 1
            }
          }
          // 柱状图处理
          var deviecList = []
          data.chartDeviceList.forEach((item, index) => {
            var s = 0
            item.siteUserDeviceList.forEach(function (item1) {
              item1.real_number >= item1.norm_number ? s = s + 1:''//如果实际数量大于应有数量
            })
            if (s !== item.siteUserDeviceList.length) { // 如果有一个实际数量没有大于应有数量就要显示该组数据
              deviecList.push(item)
            }
          })
          //        var deviecList = []
          //        var k = 0
          //        for (let i = 0; i < data.chartDeviceList.length; i++) {
          //          let item = data.chartDeviceList[i]
          //          if (item.subList.length > 0) {
          //            for (let j = 0; j < item.subList.length; j++) {
          //              let item2 = item.subList[j]
          //              let noDevice = 0
          //              for (let m = 0; m < item2.siteUserDeviceList.length; m++) {
          //                let item3 = item2.siteUserDeviceList[m]
          //                if (item3.norm_number > item3.real_number) {
          //                  noDevice = 1
          //                }
          //              }
          //              if (noDevice === 1) {
          //                let obj = {}
          //                obj.name = item2.name
          //                obj.list = item2.siteUserDeviceList
          //                deviecList[k] = obj
          //                k += 1
          //              }
          //            }
          //          } else {
          //            let noDevice = 0
          //            for (let m = 0; m < item.siteUserDeviceList.length; m++) {
          //              let item3 = item.siteUserDeviceList[m]
          //              if (item3.norm_number > item3.real_number) {
          //                noDevice = 1
          //              }
          //            }
          //            if (noDevice === 1) {
          //              let obj = {}
          //              obj.name = item.name
          //              obj.list = item.siteUserDeviceList
          //              deviecList[k] = obj
          //              k += 1
          //            }
          //          }
          //        }
          data.newUserResult.isSS = 0
          if (deviecList.length > 0) {
            data.newUserResult.isSS = 1
          }
          _this.riskData = data
          _this.riskData.deviecList = deviecList
          setTimeout(function () {
            _this.initECharts()
          }, 1000)

          // 是否 还有 未采购的设备
          var devList = []
          _this.onceOrder = 1
          for (let i = 0; i < data.siteDeviceGoodsList.length; i++) {
            let item = data.siteDeviceGoodsList[i]
            let number = item.req_number - item.commit_number
            if (number > 0) {
              _this.onceOrder = 0
              break
            }
          }
          console.log('有要购买的设备=-----------------===' + data.newUserResult.isSS)
          console.log('onceOrder=-----------------===' + _this.onceOrder)
          console.log(devList)
          _this.bottomTitle = '一键解决'
          if (_this.onceOrder === 1 && data.siteDeviceGoodsList.length > 0) {
            _this.bottomTitle = '一键采购'
          }
          // 是否有 未支付 订单
          _this.loadOrderState()
        }
      })
    },
    loadOrderState: function () {
      var _this = this
      let resultId = this.$route.query.resultId
      this.utils.GET(this.companyUrl + '/zxOrder/getOrderByEvalResultId?riskevalResultId=' + resultId, function (response) {
        if (response.data === undefined) {
          return
        }
        _this.orderListData = response.data
      })
    },
    binBack: function () {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL)
      })
    }
  },
  watch: {
    $router () {
    }
  },
  computed: {
  },
  components: {
    mainHeader,
    bottomButton,
    bottomButton2,
    payView,
    AlertView,
    previewImage
  },
  mounted () {
    this.loadData()

    this.binBack()
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
  }
}
</script>

<style scoped>
  a {
    text-decoration: underline;
    color: #c41335;
  }
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .wrapper {
    background-color: #f4f4f4;
    margin-top: 55px;
    /*padding-bottom: 65px;*/
    /*border: solid 10px red;*/
    /*box-sizing: border-box;*/
  }
  .binScroll{
    height: 300px;
    overflow: hidden;
  }
  .section {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
    background-color: #FFFFFF;
  }
  .section1{
    height: 50px;
    margin-bottom: 10px;
  }
  .section1 .title{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }
  .section2{
    height: 250px;
    background-image: url("../assets/icon_eva_result.jpg");
    background-size: cover;
    background-position: center center;
    overflow: hidden;
  }
  .section2 .title{
    padding-top: 20px;
    height: 40px;
    line-height: 40px;
    color: #FFFFFF;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
  }
  .section2 .subtitle{
    padding-top: 16px;
    height: 20px;
    line-height: 20px;
    color: #BBBBBB;
    font-size: 12px;
    text-align: center;
  }
  .section2 .circle-box{
    margin: 35px auto auto auto;
    width: 80px;
    height: 80px;
    border-radius: 40px;
    background-color: rgba(196,19,53,0.7);

    text-align: center;
  }
  .section2 .circle-box .tip{
    padding-top: 20px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .section2 .circle-box .value{
    font-size: 18px;
    color: #FFFF00;
    font-weight: bold;
    font-style:italic;
  }
  .section2 .circle-box .value span{
    font-size: 11px;
    color: #FFFFFF;
    font-weight: normal;
  }
  .section2 .rank-box{
    position: relative;
    margin: 15px 30px auto 30px;
    height: 50px;
    background-color: rgba(36,42,89,0.9);
    color: #FFFFFF;
  }
  .section2 .rank-box .left{
    position: absolute;
    left: 10px;
    top: 16px;
    height: 18px;
    line-height: 18px;
  }
  .section2 .rank-box .left .tip{
    font-size: 10px;
    color: #FFFFFF;
  }
  .section2 .rank-box .left .value{
    font-size:11px;
    font-style:italic;
    font-weight: bold;
    color: #FFFFFF;
  }
  .section2 .rank-box .left .rank{
    font-size: 10px;
    color: #E5CF9C;
    border-bottom:solid #E5CF9C 1px;
    box-sizing: border-box;
  }
  .section2 .rank-box .left img{
    width: 10px;
    height: 10px;
  }
  .section2 .rank-box .right{
    position: absolute;
    left: 52%;
    width: 48%;
  }
  .section2 .rank-box .right img{
    width: 8px;
    height: 8px;
  }
  .section2 .rank-box .right .top{
    position: absolute;
    top: 9px;
    height: 15px;
  }
  .section2 .rank-box .right .bottom{
    position: absolute;
    top: 27px;
    height: 15px;
  }
  .section2 .rank-box .right .tip{
    color: #8FA4E0;
  }
  .section2 .rank-box .right .tip{
    color: #8FA4E0;
    font-size: 10px;
  }
  .section2 .rank-box .right .value{
    color: #FFFFFF;
    font-size: 10px;
  }
  .section2 .rank-box .right .line{
    color: #435794;
    font-size: 10px;
  }
  .section2 .rank-box .right .rank{
    color: #CFAA74;
    font-size: 10px;
  }
  .section3{
    position: relative;
    height: 190px;
  }
  .section33{
    background-image: url("../assets/icon-eva-bg.jpg");
    background-size: cover;
    background-position: center center;
    text-align: center;
    height: 180px;
  }
  .section33 img{
    margin-top: 30px;
    height: 80px;
    width: 80px;
  }
  .section33 div{
    margin-top: 5px;
    font-size: 13px;
    color: #000;
  }
  .section33 div span{
    font-size: 16px;
    color: #c41335;
  }
  .section3 .header,.section4 .header{
    position: relative;
    height: 60px;
    width: 100%;
    text-align: center;
  }
  .section5 .header{
    position: relative;
    height: 60px;
    width: 100%;
    text-align: center;
  }
  .section3 .header .line,.section4 .header .line,.section5 .header .line{
    position: absolute;
    left: 0px;
    right: 0px;
    top: 29px;
    width: 100%;
    height: 1px;
    background-color: #DDDDDD;
  }
  .section3 .header .title,.section4 .header .title,.section5 .header .title{
    position: relative;
    top: 20px;
    height: 18px;
    line-height: 18px;
    background-color: #FFFFFF;
    font-size: 14px;
    color: #000000;
  }
  .section4 .header .title{
    background-color: #F9F9F9;
  }
  .section3 .header .title span,.section4 .header .title span,.section5 .header .title span{
    color: #DDDDDD;
  }
  .section3 .rate-chart-box{
    position: absolute;
    top: 68px;
    width: 100%;
    /*background-color: #FFEECC;*/
  }
  .section3 .rate-chart-box div:nth-child(1){
    margin-left: 20px;
  }
  .section3 .rate-chart-box div{
    margin-left:calc((100% - 340px)/2);
    width: 100px;
    height: 100px;
    float: left;
    overflow: hidden;
  }
  .section3 .rate-chart-value{
    position: absolute;
    top: 76px;
    width: 100%;
  }
  .section3 .rate-chart-value .rate-value{
    margin-left:calc((100% - 340px)/2);
    width: 100px;
    height: 80px;
    float: left;
    overflow: hidden;
  }
  .section3 .rate-chart-value .rate-value:nth-child(1){
    margin-left: 20px;
  }
  .section3 .rate-chart-value .rate-value .rate{
    margin-top: 18px;
    width: 100px;
    height: 22px;
    float: left;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    color: #c41335;
  }
  .section3 .rate-chart-value .rate-value .title{
    width: 100px;
    height: 20px;
    float: left;
    text-align: center;
    font-size: 12px;
    color: #000000;
  }
  .section4{
    height: 340px;
    background-color: #F9F9F9;
  }
  .section4 .content{
    position: relative;
    top: 0px;
    height: 280px;
  }
  .section4 .content .swiperRate{
    width: 100%;
    height: 280px;
    /*overflow: hidden;*/
    /*background-color: pink;*/
  }
  .section4 .content .swiperRate .chart{
    position: absolute;
    left: 15px;
    right: 15px;
    height: 280px;
    /*background-color: yellow;*/

  }
  .section4 .content .swiperRate .chart div{
    height: 280px;
    width: 100%;
    /*background-color: yellow;*/
  }
  .section4 .content .swiper-pagination{
    position: absolute;
    top:255px;
    height:25px;
    width:100%;
  }
  .section5{
    position: relative;
    /*padding-bottom: 15px;*/
    padding-bottom: 50px;
  }
  .section5 .tip-box{
    position: relative;
    margin: 10px 15px 0 15px;
    min-height: 55px;
  }
  .section5 .tip-box img{
    position: absolute;
    top: 2px;
    left: 5px;
    width: 12px;
    height: 12px;
  }
  .section5 .tip-box .tip{
    position: absolute;
    top: 0px;
    left: 20px;
    right: 0px;
    height: 16px;
    line-height: 16px;
    text-align: left;
    color: #c41335;
    font-size: 13px;
    font-weight: bold;
  }

  .section5 .content{
    position: relative;
    background-color: #FFECEC;
    margin-left: 15px;
    margin-right: 15px;
    padding-bottom: 10px;
    /*padding-bottom: 100px;*/
    /*margin-bottom: 50px;*/
    /*padding-top: 100px;*/
    min-height: 110px;
  }
  .section5 .content .header{
    position: relative;
    margin-left: 13px;
    margin-right: 15px;
    padding-top: 12px;
    height: 130px;
    /*background-color: yellow;*/
  }
  .section5 .content .header .tip{
    height: 18px;
    line-height: 18px;
    color: #000000;
    font-weight: bold;
    font-size: 13px;
    text-align: left;
  }
  .section5 .content .header .tip a{
    color: #c41335;
    font-weight: normal;
    font-size: 13px;
    height: 24px;
    line-height: 24px;
  }
  .section5 .content .center{
    position: relative;
    /*top: 50px;*/
  }
  .section5 .content .center .item-box{
    position: relative;
    margin: 0 15px;
  }
  .section5 .content .center .item-box .title{
    position: relative;
    width: 100%;
    font-size: 15px;
    font-weight: bold;
    color: #c41335;
    height: 35px;
    line-height: 35px;
    margin-top: 10px;
  }
  .section5 .content .center .item-box .value{
    position: relative;
    margin-bottom: 5px;
    /*text-align: left;*/
    /*background-color: yellow;*/
  }
  .section5 .content .center .item-box .value .index1{
    position: relative;
    font-size: 13px;
    font-weight: bold;
    color: #000000;
    height: 25px;
    line-height: 25px;
  }
  .section5 .content .center .item-box .value .tipvalue1{
    position: relative;
    font-size: 13px;
    font-weight: normal;
    color: #000000;
    height: 25px;
    line-height: 25px;
  }
  .section5 .content .center .item-box1 .value .title1{
    font-size: 13px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    color: #000000;
  }
  .section5 .content .center .item-box1 .value .value2 .title2{
    font-size: 13px;
    font-weight: normal;
    height: 20px;
    line-height: 20px;
    color: #c41335;
  }
  .section5 .content .center .item-box1 .value .value2 .title2 span{
    color: #000;
  }
  .section5 .content .center .item-box1 .value .tip-title{
    margin-top: 8px;
    font-size: 13px;
    color: #c41335;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }
  .section5 .content .center .item-box1 .value .tip-value{
    position: relative;
    font-size: 13px;
    font-weight: normal;
    height: 25px;
    line-height: 25px;
    color: #000000;
  }
  .section5 .content .center .item-box1 .value .tip2-title{
    position: relative;
    margin-top: 10px;
    font-size: 13px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    color: #c41335;
  }
  .section5 .content .center .item-box1 .value .tip3-btn{
    position: relative;
    font-size: 14px;
    font-weight: normal;
    width: 85px;
    height: 20px;
    line-height: 20px;
    margin-bottom: 10px;
    color: #c41335;
    border-bottom: solid #C41335 1px;
    box-sizing: border-box;
  }
  .section5 .content .center .item-box1 .value .item-box2{
    background-color: #FECDCD;
    padding: 10px 10px 0 10px;
  }
  .section5 .content .center .item-box1 .value .item-box2:last-child{
    padding-bottom: 10px;
  }
  .section5 .content .center .item-box1 .value .item-box2 .title2{
    position: relative;
    width: 100%;
    font-size: 13px;
    font-weight: bold;
    color: #000000;
    height: 30px;
    line-height: 30px;
  }
  .section5 .content .center .item-box1 .value .item-box2 .value2 .title3{
    font-size: 13px;
    font-weight: normal;
    height: 20px;
    line-height: 20px;
    color: #c41335;
  }
  .section5 .content .center .item-box1 .value .item-box2 .value2 .title3 span{
    color: #000000;
  }
  .markBlur{
    -webkit-filter: blur(3px);
  }
  /*.section2 .rank-box,.section3,.section4,.section5{*/
  /*  -webkit-filter: blur(3px);*/
  /*}*/
  .mark-view{
    position: fixed;
    top: 305px;
    left: 0px;
    right: 0px;
    bottom: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(255,255,255,0.6);
  }
  .mark-view .content {
    position: absolute;
    left: 0;
    top: 90px;
    right: 0;
    height: 50px;
    line-height: 25px;
    color: #000000;
    font-size: 17px;
    text-align: center;
    font-weight: normal;
  }
  .mark-view .content span{
    color: #c41335;
    font-weight: bold;
  }
  .mark-view .lookBtn {
    position: absolute;
    left: 0px;
    right: 0px;
    margin: 0 auto;
    width: 180px;
    height: 45px;
    line-height: 45px;
    top: 170px;
    background-color: #c41335;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/evaluate-result.vue